<template>
  <div class="price-list">
    <el-row :gutter="20">
      <span v-if="loading">Loading...</span>
      <span v-else-if="error">Error</span>

      <template
        v-else-if="planNames"
        v-for="(item, index) in planNames.plan.plans">
        <el-col
          :span="cloSpan"
          v-if="item.custom == 1"
          :key="index">
          <el-card  class="box-card">
            <!-- <div class="card-header">
            <span class="title"> {{ planeNameModify(item) }}</span>
          </div> -->
            <CardPlanDetails
              v-if="item"
              :planDetails="item"
              :session = "session"
              :emailid="emailid"
              :indexData="index" />
          </el-card>
        </el-col>
      </template>

    </el-row>
  </div>
</template>
<script>
import json from '../json/data.json'
import { GET_NAMES, GET_SUBS } from '../queries.js' // GET_PLAN_DETAILS
import CardPlanDetails from '@/components/CardPlanDetails.vue'
import axios from 'axios'
import Helper from '../common/helper'

export default {
  name: 'Card',
  components: {
    CardPlanDetails
  },
  data () {
    return {
      subscriptionPlanObj: json,
      planNames: '',
      loading: false,
      error: false,
      // emailid: null,
      session: null,
      subscription: null,
      cloSpan: 6
    }
  },
  apollo: {
    plans: {
      query: GET_NAMES,
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      credentials: true,
      variables () {
        return {
          customerId: this.emailid,
          product: 'Partyline'
        }
      },
      result ({ data, loading, error }) {
        // 1 Week 2 Monthly 3 Year
        data && data.plan && data.plan.plans && data.plan.plans.forEach(i => {
          i._metadata = JSON.parse(i.metadata)
          if (i.id === 'partyline-gallery') {
            this.$store.commit('saveGallery', i)
          }
          i.cycle = this.handlecycle(i.chargeCycle)
        })
        this.planNames = data
        this.loading = loading
        this.error = error
      }
    },
    subs: {
      query: GET_SUBS,
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      credentials: true,
      variables () {
        return {
          product: 'Partyline',
          status: 0
        }
      },
      result ({ data, loading, error }) {
        console.log(data, loading, error)
        this.subscription = data
        this.loading = loading
        this.error = error
      }
    }
  },
  methods: {
    planeNameModify (name) {
      let str = name.replace('partyline-common-', '')
      return str.charAt(0).toUpperCase() + str.slice(1)
    },

    getEmailIdBasedOnSession () {
      let session = Helper.getKey('session')
      this.session = session
      // console.log(session)
      let path = window.CONFIG.getEmailPath + '?session=' + session
      // console.log(window.CONFIG.getEmailPath)
      // console.log(path);
      axios
        .post(path)
        .then((response) => {
          console.log(response.status)
          // console.log(response);
          if (response.status == 200) {
            if (response.data.errorCode != '0x0') {
              console.log('redirect to login page')
              let loginUrl =
                window.CONFIG.redirect +
                '?url=' +
                window.location.origin +
                '&serviceName=PaywallAPP'
              console.log('loginUrl -->', loginUrl)
              window.location.replace(loginUrl)
            }
          }
          if (response.data && response.data.user && response.data.user.email) {
            this.emailid = response.data.user.email
            // this.emailid = "mma@tvu.com";
            localStorage.setItem('EMAILID', this.emailid)
            console.log(this.emailid)
          }
        })
        .catch((error) => {
          console.error('There was an error!', error)
        })
    },

    handleSubPlan () {
      if (!this.planNames || !this.planNames.plan || !this.planNames.plan.plans) return
      if (!this.subscription || !this.subscription.subscription || !this.subscription.subscription.subscriptions) return
      this.planNames.plan.plans.forEach(i => {
        i.isSub = this.subscription.subscription.subscriptions.findIndex(j => i.id === j.planId) > -1
      })
    },

    handleResize () {
      const clientWidth = document.documentElement.clientWidth
      this.cloSpan = clientWidth < 810 ? 12 : 6
    },
    handlecycle (cycle) {
      return cycle === 1 ? 'Week' : cycle === 2 ? 'Monthly' : cycle === 3 ? 'Year' : ''
    }
  },
  mounted () {
    // this.getEmailIdBasedOnSession()
    window.addEventListener('resize', this.handleResize)
  },
  created () {
    this.handleResize()
  },
  watch: {
    subscription () {
      this.handleSubPlan()
    },
    planNames () {
      this.handleSubPlan()
    }
  },
  computed: {
    emailid () {
      return this.$store.state.userInfo.email
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style>
.price {
  color: #505050;
  font-weight: bold;
  font-size: 30px;
  line-height: 37px;
  text-align: center;
  margin-bottom: 20px;
}
.title {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: #7f8086;
}
.el-icon-check {
  color: #7cc855;
  font-size: 15px;
  bottom: 0px;
  position: relative;
  margin-right: 10px;
  border: 1px solid #7cc855;
  border-radius: 50%;
  background: rgba(124, 200, 85, 0.14);
  padding: 2px;
  box-sizing: border-box;
}
.text {
  padding: 8px 0px;
  font-weight: 500;
  text-align: left;
  color: #858585;
  font-size: 18px;
}
.text-small {
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #a9a9a9;
  padding: 5px;
  font-weight: 300;
  display:block;
}
.price-list .el-card {
  border-radius: 11px;
  box-shadow: 0px 2px 7px 2px rgba(0, 0, 0, 0.1);
}
.price-list .el-card__body {
  position: relative;
  min-height: 300px;
  padding:15px;
}
.price-list .card-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fafafa;
  height: 82px;
  border-top: 2px solid #e9e9ea;
  display: flex;
  align-items: center;
  justify-content: center;
}
.price-list .card-footer button {
  background: #7cc855;
  border: none;
  border-radius: 11px;
  width: 122px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.price-list .card-header {
  text-align: center;
  margin-bottom: 5px;
}
.el-col{
  margin-bottom: 20px;
}
</style>
